module.exports = __webpack_public_path__ + "img/en.697e702a.png";